import { Injectable, inject } from "@angular/core";
import type { Guid } from "@kiraah-shared/common";
import { Observable } from "rxjs";
import { MobileVoiceReportApiClient } from "./mobile-voice-report-api.client";
import type { IMobileVoiceReportProcessResult, IMobileVoiceReportValidatePayload } from "../models/mobile-voice-report.models";

@Injectable({ providedIn: "root" })
export class MobileVoiceReportService {
  private readonly api = inject(MobileVoiceReportApiClient);

  processAudio(missionUid: Guid, audio: Blob): Observable<IMobileVoiceReportProcessResult> {
    return this.api.processAudio(missionUid, audio);
  }

  validate(payload: IMobileVoiceReportValidatePayload): Observable<void> {
    return this.api.validate(payload);
  }
}
